function jsonParse(value) {
  try {
    return JSON.parse(value);
  } catch {
    return void 0;
  }
}
export {
  jsonParse
};
//# sourceMappingURL=jsonParse.mjs.map